<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline pt-1 pr-1">
          Confirm Archive
          <v-spacer></v-spacer>
          <v-btn icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pb-1"> Are you sure you want archive this document type?</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn outlined color="accent"  @click="archive">Archive</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    documentType: {
      type: Object
    }
  },
  methods: {
    ...mapActions({
      archiveDocumentType: 'documentType/archiveDocumentType'
    }),
    async archive () {
      await this.archiveDocumentType(this.documentType.id)
      this.toggle()
    }
  }
}
</script>
